import { render } from "./OrganizationChart.vue?vue&type=template&id=351a032a&scoped=true"
import script from "./OrganizationChart.vue?vue&type=script&lang=js"
export * from "./OrganizationChart.vue?vue&type=script&lang=js"

import "./OrganizationChart.vue?vue&type=style&index=0&id=351a032a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a032a"]])

export default __exports__